// GroupTabs.js
// Displays tabs for switching between sampling groups in Field Notes

import React from "react";
import styles from "../FieldNotesTab.module.css";

export const GroupTabs = ({ groups, activeGroupId, setActiveGroupId }) => {
  if (!groups || groups.length === 0) {
    return <div className={styles.noGroupsMessage}>No groups available.</div>;
  }

  return (
    <div className={styles.groupTabsContainer}>
      <div className={styles.groupTabs}>
        {groups.map((group) => (
          <button
            key={group.id}
            className={`${styles.groupTab} ${
              activeGroupId === group.id ? styles.activeGroupTab : ""
            }`}
            onClick={() => setActiveGroupId(group.id)}
          >
            {group.groupName || "Unnamed Group"}
          </button>
        ))}
      </div>
    </div>
  );
};
